
export const url = "https://ma-backend.enablingtransitions.org/api";
export const tdf_url = "https://main-tdf.enablingtransitions.org";